import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import useCSRFToken from 'hooks/use-csrf-token';

import client from '../client';

import type { MarkFreelancerAsNoshowInputRequest, Response } from '../types';

interface UseMarkFreelancerAsNoshowInput {
  data: MarkFreelancerAsNoshowInputRequest;
  jobId: number;
}

const useMarkFreelancerAsNoshow = (): UseMutationResult<
  Response,
  string,
  UseMarkFreelancerAsNoshowInput,
  unknown
> => {
  const csrfToken = useCSRFToken();
  const mutation = useMutation<
    Response,
    string,
    UseMarkFreelancerAsNoshowInput,
    unknown
  >(
    'mark-freelancer-as-noshow',
    async (request: UseMarkFreelancerAsNoshowInput) => {
      const response = await fetch(`/api/job/${request.jobId}/no-show/`, {
        body: JSON.stringify(request.data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
        method: 'POST',
      });

      if (response.ok) return response.json();
      throw new Error('Something went wrong');
    },
    {
      onSuccess: () => {
        const queriesToInvalidate = [
          'organization-jobs',
          'paginated-organization-jobs',
          'job-details',
        ];
        queriesToInvalidate.forEach((query) => {
          client.invalidateQueries(query);
        });
      },
    },
  );

  return mutation;
};

export default useMarkFreelancerAsNoshow;
